import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

let btns;
let nav;
let navList;
let navListItems;
let parentListItems = [];
let runningResizeHandler = false;
let runningKeydownHandler = false;
let scrollContainer;
let subMenus = [];

const singleMode = true;
const navMaxWidth = 1023; // LG breakpoint 1024px.

const clsOpen = "is-open";
const clsRotate = "rotate-180";
const clsSubMenuToggle = "sub-menu-toggle";

const updateState = (state, selector, property) => {
    const els = document.querySelectorAll(selector);

    els.forEach((el) => {
        const styles = el.dataset[property];
        const classes = JSON.parse(styles || "{}");

        const openArr = classes.open.split(" ");
        const closedArr = classes.closed.split(" ");

        if (state === "open") {
            el.classList.add(...openArr);
            el.classList.remove(...closedArr);
        } else if (state === "closed") {
            el.classList.add(...closedArr);
            el.classList.remove(...openArr);
        }
    });
};

const closeMobileNavOnDesktop = () => {
    if (window.innerWidth > navMaxWidth) {
        closeNav();
    }
    runningResizeHandler = false;
};

const resizeHandler = () => {
    if (!runningResizeHandler) {
        runningResizeHandler = true;
        if (window.requestAnimationFrame) {
            window.requestAnimationFrame(() => {
                closeMobileNavOnDesktop();
            });
        } else {
            setTimeout(() => {
                closeMobileNavOnDesktop();
            }, 66);
        }
    }
};

const keydownHandler = (event) => {
    if (!runningKeydownHandler) {
        runningKeydownHandler = true;
        let isEscape = false;
        if ("key" in event) {
            isEscape = event.key === "Escape" || event.key === "Esc";
        } else {
            isEscape = event.keyCode === 27;
        }
        if (isEscape) {
            closeNav();
            runningKeydownHandler = false;
        }
    }
};

const toggleSubMenu = (event) => {
    event.preventDefault();

    let targetTrigger = event.currentTarget;

    if (targetTrigger.classList.contains(clsSubMenuToggle)) {
        targetTrigger = targetTrigger.parentElement;
    }

    const targetParentListItem = targetTrigger.parentElement;
    const targetMenu = targetTrigger.nextElementSibling;
    const targetIcon = targetTrigger.querySelector("svg");

    if (targetParentListItem.classList.contains(clsOpen)) {
        targetParentListItem.classList.remove(clsOpen);
        targetMenu.style.height = 0;
        targetIcon.classList.remove(clsRotate);
        return false;
    }

    if (singleMode) {
        targetIcon.classList.remove(clsRotate);

        for (let i = 0; i < parentListItems.length; i += 1) {
            parentListItems[i].classList.remove(clsOpen);
        }

        for (let j = 0; j < subMenus.length; j += 1) {
            subMenus[j].style.height = 0;
        }
    }

    targetIcon.classList.add(clsRotate);
    targetParentListItem.classList.add(clsOpen);
    targetMenu.style.height = targetMenu.getAttribute("data-height");
};

const addSubMenuEvents = () => {
    for (let i = 0; i < parentListItems.length; i += 1) {
        const el = parentListItems[i];
        const link = el.firstElementChild;
        const menu = link.nextElementSibling;

        // Set the sub menu height.
        const height = menu.offsetHeight;
        menu.setAttribute("data-height", `${height}px`);
        menu.style.height = 0;

        // Add event listener to toggle sub menu open/close.
        link.addEventListener("click", toggleSubMenu, false);
    }
};

const openNav = () => {
    updateState("open", "[data-nav-modifiers]", "navModifiers");
    disableBodyScroll(scrollContainer);
    window.addEventListener("keydown", keydownHandler, true);
    window.addEventListener("resize", resizeHandler, true);
};

const closeNav = () => {
    updateState("closed", "[data-nav-modifiers]", "navModifiers");
    enableBodyScroll(scrollContainer);
    window.removeEventListener("keydown", keydownHandler, true);
    window.removeEventListener("resize", resizeHandler, true);
};

const isNavOpen = () => {
    if (nav.classList.contains("visible")) {
        return true;
    } else {
        return false;
    }
};

const toggleNav = () => {
    if (isNavOpen() === true) {
        closeNav();
    } else {
        openNav();
    }
};

const NavOverlay = () => {
    nav = document.querySelector("[data-nav]");
    if (nav === null) {
        return;
    }

    btns = document.querySelectorAll("[data-nav-trigger]");
    scrollContainer = nav.querySelector("[data-nav-container]");

    navList = document.querySelector("[data-nav-list]");
    navListItems = navList.querySelectorAll("li");
    for (let i = 0; i < navListItems.length; i += 1) {
        const subMenu = navListItems[i].querySelector("ul");
        if (subMenu) {
            parentListItems.push(navListItems[i]);
            subMenus.push(subMenu);
        }
    }

    btns.forEach((btn) => {
        btn.addEventListener("click", toggleNav, false);
    });

    addSubMenuEvents();
};

export default NavOverlay;
